import React, { useEffect, useRef, useState } from 'react';
import Dice from './dice/Dice';
import Monster from './monster/Monster';
import dice from "../../assets/Images/dice.png";
import monster from "../../assets/Images/monster.png";

type TabKey = "dice" | "monster";

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: "dice", label: "DICE Search", icon: "pi pi-clock" },
  { key: "monster", label: "MONSTER Search", icon: "pi pi-file" },
];

const ExternalSearchConsultant = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("dice");

  const renderContent = () => {
    switch (activeTab) {
      case "dice":
        return <Dice />;
      case "monster":
        return <Monster />;
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", gap: "4px", marginTop: "8px", borderBottom: "2px solid #dee2e6" }}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "9px 18px",
                border: "none",
                borderBottom: isActive ? "2px solid #3B82F6" : "2px solid transparent",
                borderRadius: "0",
                cursor: "pointer",
                fontWeight: isActive ? "700" : "500",
                fontSize: "13px",
                backgroundColor: "transparent",
                color: isActive ? "#3B82F6" : "#374151",
                marginBottom: "-2px",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
            >
              {tab.key === "dice" && <img src={dice} width={25} alt="dice" />}
              {tab.key === "monster" && <img src={monster} width={47} alt="dice" />}
              {tab.label}
            </button>
          );
        })}
      </div>

      <div style={{ marginTop: "8px" }}>{renderContent()}</div>
    </>
  )
}

export default ExternalSearchConsultant
